// Entrada unica del modulo mockup.
//
// La demo se activa SIEMPRE desde el formulario de login estandar usando las
// credenciales DEMO_LOGIN_CREDENTIALS. No hace falta variable de entorno ni
// nada manual — funciona tal cual en el sitio publicado.
//
// Flujo:
//   1) Usuario entra demo/demo2026 en /login.
//   2) login.js detecta las credenciales y llama arrancarDemo().
//   3) arrancarDemo() instala el interceptor de fetch, marca la sesion como
//      demo en localStorage y prefija usuario/empresa/colores.
//   4) En cada reload del navegador, inicializarDemoSiCorresponde() (llamado
//      desde src/index.js al boot) detecta el flag y reinstala el interceptor.
//   5) Al volver a /login (logout u otro), login.js llama detenerDemo() para
//      que un usuario real pueda autenticarse sin que el mock intercepte.

import {
  activarSesionDemo,
  desactivarSesionDemo,
  esSesionDemo,
  DEMO_FLAG_KEY,
  DEMO_LOGIN_CREDENTIALS,
  DEMO,
} from "./demoData";
import {
  instalarMockFetch,
  desinstalarMockFetch,
  estaInstaladoMockFetch,
  resetMockState,
} from "./mockFetch";

// Arranca la demo "en caliente" — instala el interceptor y deja la sesion
// lista para navegar directo a /dashboard.
export function arrancarDemo({ autoLogin = true } = {}) {
  instalarMockFetch();
  if (autoLogin) activarSesionDemo();
}

// Apaga completamente la demo (interceptor + localStorage).
export function detenerDemo() {
  desinstalarMockFetch();
  desactivarSesionDemo();
}

// Llamado al boot de la app (src/index.js). Si la sesion previa quedo en modo
// demo (p.ej. el usuario recargo la pagina), reinstala el interceptor para
// que el localStorage existente vuelva a ser consistente con datos mock.
export function inicializarDemoSiCorresponde() {
  try {
    if (typeof window === "undefined") return false;
    if (localStorage.getItem(DEMO_FLAG_KEY) === "1") {
      instalarMockFetch();
      return true;
    }
  } catch {
    // localStorage no disponible (SSR / modo incognito muy restrictivo)
  }
  return false;
}

// Atajo para detectar si unas credenciales corresponden a la demo. Lo usa
// el formulario de login antes de pegarle al backend real.
export function sonCredencialesDemo(usuario, pass) {
  return (
    usuario === DEMO_LOGIN_CREDENTIALS.usuario &&
    pass === DEMO_LOGIN_CREDENTIALS.pass
  );
}

export {
  DEMO,
  DEMO_LOGIN_CREDENTIALS,
  DEMO_FLAG_KEY,
  activarSesionDemo,
  desactivarSesionDemo,
  esSesionDemo,
  instalarMockFetch,
  desinstalarMockFetch,
  estaInstaladoMockFetch,
  resetMockState,
};

export default DEMO;
